import React, { useEffect } from 'react';
import { Typography, Grid, FormControlLabel, Checkbox } from '@material-ui/core';
import DescriptionIcon from "@material-ui/icons/Description";
import GererGroupe from "../../components/GererGroupe/GererGroupe";
import TableActiviteDetails from '../../components/table/TableActiviteDetails';
import MUIDataTable from 'mui-datatables';
import AccordionActivity from '../../components/AccordionActivity/AccordionActivity';
import { useModal } from "../../components/general/modalContext";
import ButtonStyled from '../../components/general/ButtonStyled';
import textLabels from "../../components/dataTable/textLabel";
import { Link } from "react-router-dom";

const ActivityModal = ({
    open,
    handleClose,
    nom,
    description,
    myContext,
    showInfosPlus,
    showGererGrp,
    restrict,
    handleChangeCheck,
    showChoisir,
    idSousActivites,
    currentUser,
    manifParams,
    setShowGererGrp,
    setIdTrancheHoraire,
    setDateTranche,
    setHoraireTranche,
    descriptionLongue,
    infos,
    idTrancheHoraire,
    dateTranche,
    horaireTranche,
    ChoisirAct,
    GererGRP,
    setReload,
}) => {
    const { openModal, closeModal, isOpen } = useModal();

    const columns = [
        {
            label: "ID",
            name: "ID",
            options: {
                viewColumns: false,
                filter: false,
                display: "excluded",
            },
        },
        {
            label: " ",
            name: "ID",
            options: {
                viewColumns: false,
                filter: false,
                // display: 'excluded',
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Link
                            to={{
                                pathname: `/documents/download?vid=${value}`,
                            }}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <DescriptionIcon color="primary" />
                        </Link>
                    );
                },
            },
        },
        {
            label: "Nom",
            name: "Nom",
            options: {
                filter: true,
                sortThirdClickReset: true,
            },
        },
        {
            label: "Date version",
            name: "DateHeureVersion",
            options: {
                filter: true,
                sortThirdClickReset: true,
            },
        },
    ];

    const options = {
        responsive: "simple",
        filterType: "checkbox",
        selectableRowsHeader: false,
        filter: false,
        search: false,
        download: false,
        print: false,
        viewColumns: false,
        selectableRows: "none",
        textLabels: textLabels,
    };

    const styleModal = {
        width: "80vw",  // La largeur de la modal
        maxWidth: "80vw", // Limitez la largeur maximale
        overflowY: "auto", // Pour gérer le débordement vertical
    };

    // Utilisez useEffect pour ouvrir la modal lorsque "open" change
    useEffect(() => {
        if (open) {
            openModal(
                nom,
                (
                    <>
                        <div>
                            <Typography>{description}</Typography>
                            {myContext.User_Administrator && !showInfosPlus && !showGererGrp && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={restrict}
                                            onChange={handleChangeCheck}
                                            name="checked"
                                            color="primary"
                                        />
                                    }
                                    label="Afficher les dates passées"
                                />
                            )}

                            {showChoisir ? (
                                <>
                                    {showGererGrp ? (
                                        <GererGroupe
                                            idTrancheHoraire={idTrancheHoraire}
                                            dateTranche={dateTranche}
                                            horaireTranche={horaireTranche}
                                        />
                                    ) : (
                                        <Grid xs={12} item>
                                            <TableActiviteDetails
                                                numActChoosen={idSousActivites}
                                                idPerson={currentUser.User.User_Person_ID}
                                                restrict={!restrict}
                                                showGrp={
                                                    (currentUser.User.User_Administrator || currentUser.User.User_GestGroupe) &&
                                                    currentUser.connected &&
                                                    manifParams.manifParams.Modules[0].GestionGroupe
                                                }
                                                setShowGererGrp={setShowGererGrp}
                                                setIdTrancheHoraire={setIdTrancheHoraire}
                                                setDateTranche={setDateTranche}
                                                setHoraireTranche={setHoraireTranche}
                                                setReload={setReload}
                                            />
                                        </Grid>
                                    )}
                                </>
                            ) : (
                                <>
                                    {showInfosPlus ? (
                                        <>
                                            {descriptionLongue && (
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: descriptionLongue,
                                                    }}
                                                ></div>
                                            )}
                                            {infos?.length > 0 && (
                                                <MUIDataTable
                                                    title={<h3>Documents</h3>}
                                                    data={infos}
                                                    columns={columns}
                                                    options={options}
                                                />
                                            )}
                                        </>
                                    ) : (
                                        <AccordionActivity
                                            restrict={!restrict}
                                            idSousActivites={idSousActivites}
                                        />
                                    )}
                                </>
                            )}

                            {/* Boutons conditionnels */}
                            <div style={{ display: 'flex', justifyContent: 'flex-end', columnGap: '10px', marginTop: '10px' }}>
                                {!showChoisir && showInfosPlus && (
                                    <ButtonStyled
                                        variant="contained"
                                        color="primary"
                                        onClick={() => ChoisirAct(idSousActivites, description, nom)}
                                    >
                                        Choisir
                                    </ButtonStyled>
                                )}
                                {showGererGrp && !showInfosPlus && (
                                    <ButtonStyled
                                        variant="contained"
                                        color="primary"
                                        onClick={() => GererGRP(idSousActivites, description, nom)}
                                    >
                                        Retour
                                    </ButtonStyled>
                                )}
                                <ButtonStyled
                                    variant="contained"
                                    color="errorBtn"
                                    onClick={() => {
                                        closeModal();
                                        handleClose();
                                    }}
                                >
                                    Fermer
                                </ButtonStyled>
                            </div>
                        </div>
                    </>
                ), styleModal, () => { handleClose(); }
            );
        }
        // eslint-disable-next-line
    }, [open, isOpen, showGererGrp, showChoisir, infos, restrict]);

    return null;
};

export default ActivityModal;